import { render, staticRenderFns } from "./copyrightDisplay.vue?vue&type=template&id=2b240fa5&scoped=true&"
import script from "./copyrightDisplay.vue?vue&type=script&lang=js&"
export * from "./copyrightDisplay.vue?vue&type=script&lang=js&"
import style0 from "./copyrightDisplay.vue?vue&type=style&index=0&id=2b240fa5&prod&lang=less&scoped=true&"
import style1 from "./copyrightDisplay.vue?vue&type=style&index=1&id=2b240fa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b240fa5",
  null
  
)

export default component.exports